export default "__VITE_ASSET__72917a21__"